import { Instance } from 'mobx-state-tree';
import { SessionCheckoutDtoModelBase } from './SessionCheckoutDtoModel.base';

/* The TypeScript type of an instance of SessionCheckoutDtoModel */
export interface SessionCheckoutDtoModelType extends Instance<typeof SessionCheckoutDtoModel.Type> {}

/* A graphql query fragment builders for SessionCheckoutDtoModel */
export { selectFromSessionCheckoutDto, sessionCheckoutDtoModelPrimitives, SessionCheckoutDtoModelSelector } from './SessionCheckoutDtoModel.base';

/**
 * SessionCheckoutDtoModel
 */
export const SessionCheckoutDtoModel = SessionCheckoutDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
